import { InputCheck, Select } from "controls";
import { DropLi } from "hooks";
import React from "react";
import SelectOutlet from "./SelectOutlet";

const InputFields = ({ values, setValues, handleInpCheck, handleInpChg }) => {
  const { PrintType } = DropLi();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-3">
        <Select
          onChange={handleInpChg}
          label="Print Type"
          name="printType"
          value={values.printType}
          options={PrintType}
          required
        />
        <SelectOutlet {...{ handleInpChg, values, setValues }} />
      </div>

      <div className="flex flex-col">
        <span className="text-[14px] font-medium uppercase text-gray-500 tracking-wide">
          Select Label Content
        </span>
        <div className="flex flex-wrap">
          <InputCheck
            onChange={handleInpCheck}
            label="Outlet Name"
            checked={values.showOutlet}
            name="showOutlet"
          />
          <InputCheck
            onChange={handleInpCheck}
            label="SKU Code"
            checked={values.showSku}
            name="showSku"
            className="min-w-[120px]"
          />
          <InputCheck
            onChange={handleInpCheck}
            label="Product Name"
            checked={values.showProdTitle}
            name="showProdTitle"
          />
          <InputCheck
            onChange={handleInpCheck}
            label="Retail Price"
            checked={values.showRtlPrice}
            name="showRtlPrice"
            className="min-w-[120px]"
          />
        </div>
      </div>
    </div>
  );
};

export default InputFields;
